var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: { main: _vm.meal.depth === 1, "col-md-12": _vm.meal.depth === 1 }
    },
    [
      _c(
        "div",
        { staticClass: "row", style: _vm.styleObject },
        [
          _c("div", { staticClass: "col-md-4" }, [
            _c("div", [
              _c("label", { staticClass: "mt-checkbox mt-checkbox-outline" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.meal.kind) +
                    " - " +
                    _vm._s(_vm.meal.mealWorkName)
                ),
                _c("br"),
                _vm._v(" "),
                _c("p", { staticStyle: { "font-size": "11px", margin: "0" } }, [
                  _vm._v(
                    _vm._s(_vm.meal.kind) + " - " + _vm._s(_vm.meal.mealName)
                  )
                ]),
                _vm._v(" "),
                _vm.showDetails
                  ? _c("div", [
                      _c("b", [_vm._v("Ilość:")]),
                      _vm._v(" " + _vm._s(_vm.meal.quantity) + " szt"),
                      _c("br"),
                      _vm._v(" "),
                      _c("b", [
                        _vm._v(_vm._s(_vm._f("trans")("brand.brand")) + ":")
                      ]),
                      _vm._v(" " + _vm._s(_vm.meal.brands)),
                      _c("br"),
                      _vm._v(" "),
                      _c("b", [
                        _vm._v(_vm._s(_vm._f("trans")("size.sizes")) + ":")
                      ]),
                      _vm._v(" " + _vm._s(_vm.meal.sizes)),
                      _c("br"),
                      _vm._v(" "),
                      _c("b", [
                        _vm._v(
                          _vm._s(_vm._f("trans")("meal.entity.types")) + ":"
                        )
                      ]),
                      _vm._v(" " + _vm._s(_vm.meal.types) + "\n          ")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("input", {
                  ref: "checkboxMeal",
                  attrs: { disabled: _vm.disabled, type: "checkbox" },
                  domProps: { value: _vm.meal.mealId, checked: _vm.isChecked },
                  on: {
                    click: function($event) {
                      return _vm.$emit("check", _vm.meal.mealId)
                    }
                  }
                }),
                _vm._v(" "),
                _c("span")
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-1" }, [
            _c("span", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isDifferentTeam || _vm.isDifferentDate,
                  expression: "isDifferentTeam || isDifferentDate"
                },
                {
                  name: "tooltip",
                  rawName: "v-tooltip.left",
                  value: "PS jest przypisany na inną zmianę",
                  expression: "'PS jest przypisany na inną zmianę'",
                  modifiers: { left: true }
                }
              ],
              staticClass: "fa fa-arrow-left text-info"
            }),
            _vm._v(" "),
            _c("span", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isTouched && _vm.meal.isGenerated,
                  expression: "!isTouched && meal.isGenerated"
                },
                {
                  name: "tooltip",
                  rawName: "v-tooltip.left",
                  value: "Wpis został wygenerowany przez automat",
                  expression: "'Wpis został wygenerowany przez automat'",
                  modifiers: { left: true }
                }
              ],
              staticClass: "fa fa-cog text-info"
            }),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("a", {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip.left",
                    value: "Przejdź do edycji posiłku",
                    expression: "'Przejdź do edycji posiłku'",
                    modifiers: { left: true }
                  }
                ],
                staticClass: "link-edit-pk fa fa-pencil-square-o text-info",
                attrs: {
                  href: "/meal/update/" + _vm.meal.mealId,
                  target: "_blank"
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-7" }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-md-2" },
                [
                  _c("date-picker", {
                    ref: "productionDate",
                    attrs: {
                      value: _vm.productionDate,
                      time: false,
                      "init-value": false,
                      disabled: _vm.disabled,
                      "can-clear": "",
                      placeholder: "Wybierz datę"
                    },
                    on: { input: _vm.changeDate, clear: _vm.clearDate }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-2" },
                [
                  _c("new-single-select", {
                    attrs: {
                      options: _vm.hours,
                      disabled: _vm.disabled,
                      placeholder: "godzina"
                    },
                    model: {
                      value: _vm.hour,
                      callback: function($$v) {
                        _vm.hour = $$v
                      },
                      expression: "hour"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-4" },
                [
                  _c("new-single-select", {
                    attrs: {
                      options: _vm.teams,
                      disabled: _vm.disabled,
                      placeholder: "zespół produkcyjny"
                    },
                    model: {
                      value: _vm.teamId,
                      callback: function($$v) {
                        _vm.teamId = $$v
                      },
                      expression: "teamId"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-2" },
                [
                  _c("new-single-select", {
                    attrs: {
                      options: _vm.unfoldingTeams,
                      disabled: _vm.disabled,
                      placeholder: "rozkładanie",
                      label: "symbol"
                    },
                    model: {
                      value: _vm.unfoldingTeamId,
                      callback: function($$v) {
                        _vm.unfoldingTeamId = $$v
                      },
                      expression: "unfoldingTeamId"
                    }
                  })
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _vm.meal.depth === 1
            ? _c("div", { staticClass: "col-md-12" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.meal.components.length > 0,
                        expression: "meal.components.length > 0"
                      }
                    ],
                    staticClass: "col-md-12"
                  },
                  [
                    _c(
                      "label",
                      { staticClass: "mt-checkbox mt-checkbox-outline" },
                      [
                        _c("div", { staticClass: "checkbox-text" }, [
                          _vm._v("Rozwiń wszystkie")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.isExpandAll,
                              expression: "isExpandAll"
                            }
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(_vm.isExpandAll)
                              ? _vm._i(_vm.isExpandAll, null) > -1
                              : _vm.isExpandAll
                          },
                          on: {
                            click: _vm.expand,
                            change: function($event) {
                              var $$a = _vm.isExpandAll,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.isExpandAll = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.isExpandAll = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.isExpandAll = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span")
                      ]
                    )
                  ]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-12" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.meal.components.length > 0,
                    expression: "meal.components.length > 0"
                  }
                ],
                staticClass: "col-md-12"
              },
              [
                !_vm.showComponents
                  ? _c(
                      "a",
                      {
                        on: {
                          click: function($event) {
                            _vm.showComponents = true
                          }
                        }
                      },
                      [_c("i", { staticClass: "fa fa-caret-down" })]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showComponents
                  ? _c(
                      "a",
                      {
                        on: {
                          click: function($event) {
                            _vm.showComponents = false
                          }
                        }
                      },
                      [_c("i", { staticClass: "fa fa-caret-up" })]
                    )
                  : _vm._e()
              ]
            )
          ]),
          _vm._v(" "),
          _vm._l(_vm.meal.components, function(mealRow, index) {
            return _c("assign-team-meal-row", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showComponents,
                  expression: "showComponents"
                }
              ],
              key: index,
              ref: "assignTeamMealRow",
              refInFor: true,
              attrs: {
                meal: mealRow,
                "is-checked": Boolean(false),
                teams: _vm.teams,
                "unfolding-teams": _vm.unfoldingTeams,
                hours: _vm.hours,
                disabled: Boolean(false),
                "show-details": Boolean(false)
              },
              on: { assingteam: _vm.componentsAssignTeam }
            })
          })
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f60464fe", { render: render, staticRenderFns: staticRenderFns })
  }
}